import React from 'react';
import { GuestContactWarning } from '../../services/GuestContactCheckService';
import { guestPath } from '../../utils/guestRoutes';

interface Props {
  warning: GuestContactWarning | null;
  onDismiss: () => void;
}

/** Inline, dismissible note under a phone or email field. A warning only: it never blocks Save. */
const DuplicateContactWarning: React.FC<Props> = ({ warning, onDismiss }) => {
  // The live region stays mounted so a screen reader announces the note when it appears.
  const guest = warning?.guest ?? null;
  const noun = warning?.field === 'phone' ? 'phone number' : 'email address';
  const href = guest ? guestPath(guest.label) : undefined;

  return (
    <div role="status" aria-live="polite">
      {warning && guest && (
        <div className="gst-dup-warning">
          <span className="gst-dup-warning__text">
            This {noun} is already used by{' '}
            {href ? (
              <a className="gst-dup-warning__link" href={href} target="_blank" rel="noopener noreferrer">{guest.name || guest.label}</a>
            ) : (
              <strong>{guest.name || guest.label}</strong>
            )}
            {guest.name && guest.label ? ` (${guest.label})` : ''}. You can still save.
          </span>
          <button type="button" className="gst-dup-warning__dismiss" onClick={onDismiss} aria-label="Dismiss this warning">Dismiss</button>
        </div>
      )}
    </div>
  );
};

export default DuplicateContactWarning;
